module.exports = __webpack_public_path__ + "media/images/emblems/Quinto-coat_of_arms-e8a75c03e901f1809fd9bc59fb1e8428.svg";